import { INACTIVITY_TIMEOUT_MINUTES } from 'hb-react/shared/hooks/useSubscribeToAblyChannel/constants';
import { InactivityPublisher } from 'hb-react/shared/utils/InactivityPublisher';
import { TabVisibilityTracker } from 'hb-react/shared/utils/InactivityPublisher/trackers/TabVisibilityTracker';
import { UserActionsTracker } from 'hb-react/shared/utils/InactivityPublisher/trackers/UserActionsTracker';

// Share between instances to reduce the number of listeners
let inactivityPublisherSingleton: InactivityPublisher | null = null;

export const getInactivityPublisherSingleton = () => {
  if (!inactivityPublisherSingleton) {
    inactivityPublisherSingleton = new InactivityPublisher([
      new TabVisibilityTracker(INACTIVITY_TIMEOUT_MINUTES * 60 * 1000),
      new UserActionsTracker(INACTIVITY_TIMEOUT_MINUTES * 60 * 1000),
    ]);
  }

  return inactivityPublisherSingleton;
};
